import { Card, CardContent, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import type { UsageLogsStats } from '@/types/domain';

interface StatsCardsProps {
  stats: UsageLogsStats | null;
  loading: boolean;
  totalCount: number;
  hasActiveFilters: boolean;
}

export default function StatsCards({
  stats,
  loading,
  totalCount,
  hasActiveFilters,
}: StatsCardsProps) {
  const { t } = useTranslation();

  if (!stats || loading) {
    return null;
  }

  return (
    <>
      {/* 通用统计卡片 */}
      <Grid container spacing={2} sx={{ mb: 2 }}>
        <Grid item xs={6} sm={3}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom variant="body2">
                {t('logs.totalLogs')}
              </Typography>
              <Typography variant="h5">{stats.totalLogs}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom variant="body2">
                {t('logs.totalActivations')}
              </Typography>
              <Typography variant="h5">{stats.totalActivations}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom variant="body2">
                {t('logs.uniqueDevices')}
              </Typography>
              <Typography variant="h5">{stats.activeDevices.length}</Typography>
            </CardContent>
          </Card>
        </Grid>
        <Grid item xs={6} sm={3}>
          <Card>
            <CardContent>
              <Typography color="text.secondary" gutterBottom variant="body2">
                {t('logs.filteredResults')}
              </Typography>
              <Typography
                variant="h5"
                color={hasActiveFilters ? 'primary.main' : 'text.primary'}
              >
                {totalCount}
              </Typography>
            </CardContent>
          </Card>
        </Grid>
      </Grid>

      {/* 许可证密钥统计卡片 */}
      {stats.licenseKeyStats.length > 0 && (
        <Grid container spacing={2} sx={{ mb: 2 }}>
          <Grid item xs={6} sm={4}>
            <Card>
              <CardContent>
                <Typography color="text.secondary" gutterBottom variant="body2">
                  {t('logs.totalLicenseKeys')}
                </Typography>
                <Typography variant="h5">{stats.licenseKeyStats.length}</Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={4}>
            <Card>
              <CardContent>
                <Typography color="text.secondary" gutterBottom variant="body2">
                  {t('logs.usedSlots')}
                </Typography>
                <Typography variant="h5">
                  {stats.licenseKeyStats.reduce((sum, lk) => sum + lk.activationCount, 0)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
          <Grid item xs={6} sm={4}>
            <Card>
              <CardContent>
                <Typography color="text.secondary" gutterBottom variant="body2">
                  {t('logs.remainingSlots')}
                </Typography>
                <Typography variant="h5" color="success.main">
                  {stats.licenseKeyStats.reduce((sum, lk) => sum + lk.remainingSlots, 0)}
                </Typography>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      )}
    </>
  );
}
